import { ref } from 'vue'
import { useAppStore } from '@/stores/app-store'
import { useUserStore } from '@/stores/user-store'
import { LocalStoreUtils } from '@/js/utils'
import { setUserPreference } from '@/requests/home-requests'

/**
 * Composable for managing modals
 * @returns {Object} - Functions and state for managing the modal
 */
export function useModal() {
	const appStore = useAppStore()
	const userStore = useUserStore()
	const isShown = ref(false)

	/**
   * Show the modal
   */
	const showModal = (options) => {
		appStore.addModal(options)
		isShown.value = true
	}

	/**
   * Check if the modal should be shown and show it if needed
   */
	const checkAndShowOnceModal = async ({ modalSlug, storageKey, unclosable, ...options } = {}) => {
		if (LocalStoreUtils.get(storageKey)) return
      
		if (userStore.isConnected) {
			await userStore.updateUser()
          
			if(!userStore.userPreferences[storageKey]){
				showModal({ slug: modalSlug, unclosable, ...options })
				LocalStoreUtils.set(storageKey, { [storageKey]: true })
				await setUserPreference({ preferences: { ...userStore.userPreferences, [storageKey]: true } })
				await userStore.updateUser()
			}

		} else {
			showModal({ slug: modalSlug, unclosable, ...options })
			LocalStoreUtils.set(storageKey, { [storageKey]: true })
		}
	}

	return {
		isShown,
		showModal,
		checkAndShowOnceModal
	}
}